import {
    DOWNGRADE_TEXT,
    LETS_TALK_TEXT,
    PACKAGE_ONE,
    PACKAGE_THREE,
    PACKAGE_TWO,
    UPGRADE_TEXT,
    YOUR_CURRENT_PACKAGE_TEXT,
} from '../../constants/main';
import { STYLE_FILL, STYLE_NEUTRAL } from '@eventbrite/eds-button';

export default {
    [PACKAGE_ONE]: {
        packagesList: {
            CTAs: [YOUR_CURRENT_PACKAGE_TEXT, UPGRADE_TEXT, LETS_TALK_TEXT],
            CTAStyles: [null, STYLE_FILL, STYLE_NEUTRAL],
        },
        grid: {
            CTAs: [YOUR_CURRENT_PACKAGE_TEXT, UPGRADE_TEXT, LETS_TALK_TEXT],
            CTAStyles: [null, STYLE_FILL, STYLE_NEUTRAL],
        },
    },
    [PACKAGE_TWO]: {
        packagesList: {
            CTAs: [DOWNGRADE_TEXT, YOUR_CURRENT_PACKAGE_TEXT, LETS_TALK_TEXT],
            CTAStyles: [STYLE_NEUTRAL, null, STYLE_FILL],
        },
        grid: {
            CTAs: [DOWNGRADE_TEXT, YOUR_CURRENT_PACKAGE_TEXT, LETS_TALK_TEXT],
            CTAStyles: [STYLE_NEUTRAL, null, STYLE_FILL],
        },
    },
    [PACKAGE_THREE]: {
        packagesList: {
            CTAs: [DOWNGRADE_TEXT, DOWNGRADE_TEXT, YOUR_CURRENT_PACKAGE_TEXT],
            CTAStyles: [STYLE_NEUTRAL, STYLE_NEUTRAL, null],
        },
        grid: {
            CTAs: [DOWNGRADE_TEXT, DOWNGRADE_TEXT, YOUR_CURRENT_PACKAGE_TEXT],
            CTAStyles: [STYLE_NEUTRAL, STYLE_NEUTRAL, null],
        },
    },
};
